import React from 'react';
import { alignSingleBarLeft, hideBarPadLabel, CHART_PALETTE_OP, CHART_TITLE_STYLE } from "../HelperFunction/helperFunction";
import ExceptionVariables from '../JSON Files/ExceptionVariables';
import Chart from 'react-apexcharts';
import { useOutletContext } from 'react-router-dom';

function SingleBarChart5op({ optimizeddatasetincrement, type, isValue, range, maxValuedynamicVolume, maxValuedynamicValue, axisMax }) {
  const { theme } = useOutletContext();
  const isDark = theme !== 'light';
  let maxValue = isValue ? maxValuedynamicValue : maxValuedynamicVolume
  let hidevar = ExceptionVariables.hiddenroichart;
  console.log(optimizeddatasetincrement)
  let filtered_data = optimizeddatasetincrement?.filter(it => it.value_contribution > 0)
  const filtered = filtered_data?.filter(varObj => !hidevar?.includes(varObj?.variable_name))
  // ?.sort((a, b) => 
  //  b.variable_name.localeCompare(a.variable_name)
  // );
  // Determine if the data contains 'frequency'
  const isStacked = filtered?.some(item => item?.frequency);
  if (isStacked) {
    maxValue = 3 * maxValue
  }
  if (Number(axisMax) > 0) maxValue = Number(axisMax);
  let categories, series;

  if (isStacked) {
    // Extract unique frequencies and variables
    let uniqueFrequencies = Array.from(new Set(filtered.map(item => item?.frequency)));
    let uniqueVariables = Array.from(new Set(filtered.map(item => item?.variable_name)));

    // Group data by variable (stacked chart case)
    series = uniqueVariables.map(variable => {
      return {
        name: variable,
        data: uniqueFrequencies.map(frequency => {
          let dataPoint = filtered.find(item => item.variable_name === variable && item.frequency === frequency);
          return dataPoint ? (isValue ? Number(dataPoint.contribution_value / 100000).toFixed(2) : Number(dataPoint.value_contribution).toFixed(0)) : 0;
        })
      };
    });
    categories = uniqueFrequencies;
  } else {
    // Extract unique variables (non-stacked case)
    let uniqueVariables = Array.from(new Set(filtered.map(item => item?.variable_name)));

    // Group data normally
    series = [{
      name: "Contribution",
      data: uniqueVariables.map(variable => {
        let dataPoint = filtered.find(item => item.variable_name === variable);
        return dataPoint ? (isValue ? Number(dataPoint.contribution_value / 100000).toFixed(2) : Number(dataPoint.value_contribution).toFixed(0)) : 0;
      })
    }];
    categories = uniqueVariables;
  }

  ({ categories, series } = alignSingleBarLeft(categories, series));
  const barColumnWidth = `${Math.min(70, Math.max(categories?.length || 1, 1) * 11)}%`;

  const options = {
    chart: {
      id: `Download-Contribution Chart for Incremental Variables`,
      type: 'bar',
      stacked: isStacked,
      toolbar: {
        show: true,
      },
      background: 'transparent',
    },
    grid: {
      show: false,
    },
    tooltip: {
      theme: isDark ? 'dark' : 'light',
    },
    title: {
      text: `Contribution ${isValue ? "Value" : "Volume"} for Incremental Variables (${type})`,
      align: 'center',
      style: CHART_TITLE_STYLE,
    },
    colors: CHART_PALETTE_OP,
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: barColumnWidth,
        dataLabels: {
          position: "top",
        },
      },
    },
    dataLabels: {
      enabled: isStacked ? false : true,
      offsetY: -15,
      style: {
        fontSize: '12px',
        fontWeight: 600,      },
      formatter: function (val) {
        return (val?.toLocaleString("en-IN"));
      },
    },
    xaxis: {
      categories: categories,
      title: {
        text: '',
        style: {
          fontWeight: 600,
          fontSize: "12px",        },
      },
      labels: {
        rotate: -40,
        rotateAlways: true,
        formatter: (val) => hideBarPadLabel(val),
        style: {
          fontWeight: 500,
          fontSize: "11px",        },
        offsetY: -6,
      },
    },
    yaxis: {
      axisBorder: {
        show: true
      },
      min: 0,
      max: Math.ceil(maxValue),
      labels: {
        style: {
          fontWeight: 500,
          fontSize: "11px",        },
        formatter: function (val) {
          return val?.toFixed(0);
        },
      },
    },
    legend: {
      show: isStacked,
      fontSize: "12px",    },
    annotations: {
      yaxis: [{
        y: 0,
        borderColor: '#939598',
        label: {
          text: '',
          style: {
            color: '#939598',
            background: '#000'
          }
        }
      }]
    },
  };

  return (
    <>
      <div className="rr-chart-period">
        <small>Time Period: {range}</small>
      </div>
      <div className="rr-chart-yaxis">
        <span className="rr-chart-yaxis-label">
          {`Contribution ${isValue ? "Value (Lacs)" : "Volume (Kgs)"}`}
        </span>
        <div className="rr-chart-yaxis-body">
          <Chart className="rr-apex rr-apex-bar"
            align="center"
            options={options}
            series={series}
            type="bar"
            height={320}
            width={'100%'}
          />
        </div>
      </div>
    </>
  );
}

export default SingleBarChart5op;


